import React from "react";

import "../styles.scss";
import "../scripts";

import { webflowHOC } from "@kameleon-common/webflow-js";
import {
  KameleonElement,
  primaryCollectionBlock,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import {
  blockConfig,
  ContentCollectionItem,
  ContentCollectionItemType,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import {
  ContentCollectionType as ComponentType,
  layoutOptions,
} from "./types/prop-types";

type ContentCollectionType = {
  PrimaryBlocks: ContentCollectionItemType[];
} & ComponentType;

const Component = ({ PrimaryBlocks, layoutProps }: ContentCollectionType) => (
  <Box className="primary-collection-content-collection-two-col-tab-headers-v1 section_layout28">
    <Box className="padding-global">
      <Box className="container-large padding-section-large">
        <Box
          data-duration-in="400"
          data-duration-out="200"
          data-current="Tab 1"
          data-easing="ease"
          className="layout28_component w-tabs"
        >
          <Box
            id="w-node-f0ba89a8-979d-48db-8d3e-820ae5231869-f3b5c4e7"
            className="w-tab-content"
          >
            {PrimaryBlocks.map((primary, i) => (
              <Box
                key={`tab-${i}`}
                data-w-tab={`Tab ${i + 1}`}
                className="w-tab-pane w--tab-active"
              >
                <Box className="layout28_image-wrapper">
                  <Variants.Image
                    loading="lazy"
                    src={primary.image.url}
                    alt={primary.image.alt}
                    className="layout28_image"
                  />
                </Box>
              </Box>
            ))}
          </Box>
          <Box
            id="w-node-f0ba89a8-979d-48db-8d3e-820ae5231853-f3b5c4e7"
            sx={{
              gridArea:
                layoutProps.mediaPlacement === "right" ? "1/1/2/2" : "0",
            }}
            className="layout28_tabs-menu w-tab-menu"
          >
            {PrimaryBlocks?.map((primaryBlockProps, i) => (
              <Box
                key={`item-${i}`}
                data-w-tab={`Tab ${i + 1}`}
                variant="links.tabActiveLeft"
                className="layout28_tabs-link w-inline-block w-tab-link w--current"
              >
                <ContentCollectionItem {...primaryBlockProps} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

const ComponentWithWebflow = webflowHOC(Component, ["tabs"]);

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({ PrimaryBlocks, ...props }: ContentCollectionType) => (
    <ComponentWithWebflow PrimaryBlocks={PrimaryBlocks} {...props} />
  )
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
